const dataAttr = (condition) => condition ? "" : void 0;
const ariaAttr = (condition) => condition ? true : void 0;

export { ariaAttr, dataAttr };
